module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAMCAYAAABFohwTAAAAjElEQVQImU3OoQ5BcQBG8d/9UzyAYiQURfMMAuEWz8A0NibY7nQP4A1M0cwj6HY3SSCINkWyCS7ztbN9ZztRkiS+a2+2y/AHXYxCBhGWeOazwwx1TKNDo1nFERe0AhYooL/vxY+AUqZdIWCMF9aQKw8Ht1p6qqBTS0/nb8cEd3zC9r34jjmKv1KssHsDH3IgzIcrX/MAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/main-menu/arrow-back.png
// module id = 284
// module chunks = 0